import { toggleDropdown } from "./UIHelpers.js";

/**
 * Represents the left panel on the home page
 */
export class LeftPanel {
    constructor(leftDiv, walkthroughVideo) {
        this.leftDiv = leftDiv;
        this.walkthroughVideo = walkthroughVideo;

        // Set event listener for toggling the zip dropdown
        const button = leftDiv.querySelector("#zip-code-container > button");
        button.addEventListener("click", () => toggleDropdown(button));
    }

    /**
     * Show the left panel
     */
    hide() {
        this.leftDiv.classList.add("offscreen-left");
        this.walkthroughVideo.classList.remove("slide-right");
        $("#menu-bar-type-2").removeClass("bg-primary")
        let search = document.querySelector("#search_bar")
        search.classList.remove('hide-mobile')
        // $("#search_bar").show();
        $('.site-header-menu-bar').addClass('pushed')
        $('.wrapper').addClass('pushed')
        $('#map-container').addClass('pushed')
    }

    /**
     * Hide the left panel
     */
    show() {
        this.leftDiv.classList.remove("offscreen-left");
        this.walkthroughVideo.classList.add("slide-right");
        $("#menu-bar-type-2").addClass("bg-primary");
        let search = document.querySelector("#search_bar")
        if(search)
        {
            search.classList.add('hide-mobile');
            search.classList.add('left-panel-open');
        }
        // $("#search_bar").hide();
        $('.site-header-menu-bar').removeClass('pushed')
        $('.wrapper').removeClass('pushed')
        $('#map-container').removeClass('pushed')
    }

    /**
     * Update the left panel with a new county's information
     * @param {String} name Name of the county
     */
    setCounty(name) {
        const countyNameHeader = this.leftDiv.querySelector(".sidebar-header");
        countyNameHeader.innerText = name + " County";
    }

    setupZipButtons(geojson, onZipMouseOver, onZipMouseLeave, onZipClick) {
        const list = this.leftDiv.querySelector("#zip-drop-list ul");
        this.fillZipList(list, geojson, onZipMouseOver, onZipMouseLeave, onZipClick);
    }

    /**
     * Create a dropdown element used in the zip, city, and schoolboard dropdowns
     * @param {String} text text to display on the item
     * @returns {Element} the created li element
     */
    createDropdownItem(text) {
        const item = document.createElement("li");
        item.classList.add("flex-row");
        item.classList.add("flex-space");

        const zipDiv = document.createElement("div");
        zipDiv.innerText = text;
        const arrow = document.createElement("img");
        arrow.setAttribute("src", "/assets/thin-arrow-gray.svg");

        const button = document.createElement("button");
        button.append(zipDiv);
        button.append(arrow);
        item.append(button);

        return item;
    }

    fillZipList(list, geojson, onZipMouseOver, onZipMouseLeave, onZipClick) {

        // Empty the previous zip list
        list.innerText = "";

        console.log(geojson)

        const features = geojson.features.map((feature, index) => ({zip: feature.properties.GEOID20, index}))
        features.sort((a, b) => a.zip > b.zip ? 1 : -1)

        for (var i = 0; i < features.length; i++) {
            const zip = features[i].zip;

            // id corresponds to the index of the feature within the geojson file
            // This is set with generateId: true in map.addSource
            const id = features[i].index

            // Add the zipcode list element
            const item = this.createDropdownItem(zip);
            list.append(item);

            const button = item.querySelector("button");

            button.onmouseover = function () {
                onZipMouseOver(zip, id)
            }

            button.onmouseout = function () {
                onZipMouseLeave(zip, id)
            }

            button.onclick = function () {
                onZipClick(zip, id)
                // toggleDropdown(this.listDiv.querySelector("#zip-code-container button"));
            }
        }
    }
}